import { toast } from 'react-toastify';

toast.configure({
  autoClose: 3000,
  draggable: false
});
